import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PublicLayout from "@/components/PublicLayout";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider } from "@/contexts/AuthContext";
import { CookieConsentProvider } from "@/contexts/CookieConsentContext";
import { CookieBanner } from "@/components/CookieBanner";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Gallery from "@/pages/Gallery";
import Booking from "@/pages/Booking";
import Contact from "@/pages/Contact";
import FAQ from "@/pages/FAQ";
import Volunteer from "@/pages/Volunteer";
import Articles from "@/pages/Articles";
import ArticleDetail from "@/pages/ArticleDetail";
import FirstConsultation from "@/pages/FirstConsultation";
import PrivacyGDPR from "@/pages/PrivacyGDPR";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiePolicy from "@/pages/CookiePolicy";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <AuthProvider>
      <CookieConsentProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/despre" element={<About />} />
              <Route path="/servicii" element={<Services />} />
              <Route path="/galerie" element={<Gallery />} />
              <Route path="/programare" element={<Booking />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/voluntariat" element={<Volunteer />} />
              <Route path="/articole" element={<Articles />} />
              <Route path="/articole/:slug" element={<ArticleDetail />} />
              <Route path="/prima-consultatie" element={<FirstConsultation />} />
              <Route path="/informare-gdpr" element={<PrivacyGDPR />} />
              <Route path="/politica-confidentialitate" element={<PrivacyPolicy />} />
              <Route path="/politica-cookies" element={<CookiePolicy />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
          <CookieBanner />
        </BrowserRouter>
      </CookieConsentProvider>
    </AuthProvider>
  );
}

export default App;
